import * as React from 'react';
import { memo, useState } from "react";
import Dump from "../../js/components/dump.tsx";
import { AssetMode } from "../../js/enums.ts";
import { getEnv } from "../../js/helpers/env.ts";
import { getImgUrl } from "../../js/mediaLibrary/assetUtils.ts";
import type { PageItemData } from "../../js/page/content.types.ts";
import Lightbox from "yet-another-react-lightbox";

type Props = React.ComponentPropsWithoutRef<"div"> & {
	item: PageItemData
}

function RenderMenuItem({item, ...otherProps}: Props) {
	const [lightbox, setLightbox] = useState<{open: boolean, index: number}>({open: false, index: 0});

	return (<>
		<div className="menuItem">
			<div className="flex gap-4 overflow-hidden">
				{item?.imageId && item?.image &&
					<a
						href={getEnv('PUBLIC_ASSET_HOST') + item.image?.linkView}
						className="block shrink-0"
						onClick={(event) => {
							event.preventDefault();
							setLightbox({ index: 0, open: true});
						}}
					>
						<img
							src={item?.imageId && getImgUrl(AssetMode.Thumb, item.imageId, item?.image?.filename, 400, 400)}
							alt={item.image.description}
							width={200}
							height={200}
							className="w-24 sm:w-32 md:w-[200px]"
						/>
					</a>}

				<div className="flex flex-col w-full shrink">
					<div className="flex gap-4 justify-between items-start w-full">
						<h6 className="font-bold">{item.title}</h6>
						{item.price && <div className="font-medium bg-primary-200 inline-block px-3 py-0.5 rounded-full text-white">
							{item.price}
						</div>}
					</div>

					<span dangerouslySetInnerHTML={{__html: item.rendered ? item.rendered : item.content}}/>

					{/*<Dump value={item}/>*/}
				</div>
			</div>
		</div>

		<Lightbox
			open={lightbox.open}
			index={lightbox.index}
			close={() => setLightbox({...lightbox, open: false})}
			render={{
				buttonPrev: () => null,
				buttonNext: () => null
			}}
			controller={{
				disableSwipeNavigation: true,
				closeOnBackdropClick: true
			}}
			slides={[
				item?.imageId ? {
					src: getEnv('PUBLIC_ASSET_HOST') + item?.image?.linkView,
					alt: item?.image?.description,
					width: item?.image?.width,
					height: item?.image?.height
				} : null
			]}
		/>

		{/*<Dump value={item.imageId}/>*/}
		{/*<Dump value={item.image}/>*/}
	</>);
}

export default memo(RenderMenuItem);
